import PropTypes from 'prop-types';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';
import {split, toNumber} from 'lodash';

import Layout from './Layout';

import ComparablesPage from 'pages/ComparablesPage';
import SoiComparableSalesPage from 'pages/SoiComparableSalesPage';
import DefaultPage from 'pages/DefaultPage';
import FinalisePage from 'pages/FinalisePage';
import NotFoundPage from 'pages/NotFoundPage';
import DashboardPage from 'pages/DashboardPage';
import CustomiseReportPage from 'pages/CustomiseReportPage';

import TopBar from 'components/TopBar';
import PageRoute from 'components/PageRoute';
import AnalyticsGateway from 'lib/AnalyticsGateway';
import PageWrapper from 'pages/PageWrapper';
import ReportStepWrapper from 'pages/ReportStepWrapper';
import AdminPhotosContainer from 'components/admin/AdminPhotosContainer';
import AdminNotesPage from 'components/admin/AdminNotesPage';
import AdminDigitalAssetsPage from 'components/admin/AdminDigitalAssetsPage';
import ReduxStore from './ReduxStore';
import {getApiLogin} from 'ducks/login';
import Favicon from 'react-favicon';
import ReduxBlockUi from 'components/commons/blockUi/ReduxBlockUi';
import { REDUX_UNBLOCKING, REDUX_BLOCKING } from 'constants/reduxLoader';

function locationHashChanged() {
  AnalyticsGateway.pageView(window.location.hash.replace('#', ''));
}

window.onhashchange = locationHashChanged;

function ApiLogin() {
  ReduxStore.dispatch(getApiLogin());
  return null;
}

export default function Routes({loggedIn, reportTypeValue, favicon, rpdBaseUrl}) {
  if (!loggedIn) {
    return window.location.replace(rpdBaseUrl);
  }
  return (
    <div>
      <Favicon url={favicon} />
        <ReduxBlockUi
            block={REDUX_BLOCKING}
            unblock={REDUX_UNBLOCKING}
            style={{
              zIndex: 1500,
            }}
        >
        <Router basename="/">
          <Switch>
            <Route path="/api/login" component={ApiLogin}/>
          </Switch>
        </Router>
        <Router basename="/#">
          <div>
            <Route component={ScrollToTop}/>
            <PageRoute insecure path="/" page={TopBar}/>
            <PageRoute insecure path="/" page={PageWrapper}>
              <Layout>
                <Switch>
                  <PageRoute exact path="/" page={DefaultPage}/>
                  <PageRoute exact path="/properties/search" page={DashboardPage}/>
                  <PageRoute path="/properties/:propertyId" page={ReportStepWrapper}>
                    <Switch>
                      <Route exact path="/properties/:propertyId" render={props =>
                          <Redirect to={`/properties/${props.match.params.propertyId}/${reportTypeValue || 'cma'}/comparable_${reportTypeValue === 'rental' ? 'rentals' : 'sales'}`} {...props} />}
                      />
                      <PageRoute exact path="/properties/:propertyId/soi/comparable_sales" page={SoiComparableSalesPage}/>
                      <PageRoute exact path="/properties/:propertyId/:reportType/comparable_rentals" render={(props) => <ComparablesPage {...props} comparableType="rentals" subComparableType="regular"/>}/>
                      <PageRoute exact path="/properties/:propertyId/:reportType/comparable_sales" render={(props) => <ComparablesPage {...props} comparableType="sales" subComparableType="regular"/>}/>
                      <PageRoute exact path="/properties/:propertyId/:reportType/comparable_listings" render={(props) => <ComparablesPage {...props} comparableType="listings" subComparableType="regular"/>}/>
                      <PageRoute exact path="/properties/:propertyId/:reportType/customise" page={CustomiseReportPage}/>
                      <PageRoute exact path="/properties/:propertyId/:reportType/finalise" page={FinalisePage}/>
                    </Switch>
                  </PageRoute>
                  {/* ADMIN */}
                  <PageRoute exact path="/admin/photos" page={AdminPhotosContainer}/>
                  <PageRoute exact path="/admin/notes" page={AdminNotesPage}/>
                  <PageRoute exact path="/admin/assets" page={AdminDigitalAssetsPage}/>
                  <Route component={NotFoundPage}/>
                </Switch>
              </Layout>
            </PageRoute>
          </div>
        </Router>
      </ReduxBlockUi>
    </div>
  );
}

Routes.propTypes = {
  loggedIn: PropTypes.bool,
  rpdBaseUrl: PropTypes.string,
  reportTypeValue: PropTypes.string,
  favicon: PropTypes.string,
  match: PropTypes.shape({
    params: PropTypes.shape({
      propertyId: PropTypes.number,
    }),
  }),
};

const ScrollToTop = () => {
  window.scrollTo(0, 0);
  return null;
};

const propertyId = (pathname) => {
  if (pathname.indexOf('/properties') === 0) {
    const components = split(pathname, '/', 3);
    const id = toNumber(components[2]);
    if (!isNaN(id)) {
      return id;
    }
  }
};

const reportType = (pathname) => {
  const components = split(pathname, '/', 4);
  if (components.length === 4) {
    const reportTypes = {cma: 'cma', soi: 'soi', rental: 'rental'};
    return reportTypes[components[3]];
  }
};

const pageContext = (pathname) => {
  if (propertyId(pathname)) {
    if (reportType(pathname)) {
      if (pathname.includes('/finalise')) {
        return 'Preview Report';
      }
      if (pathname.includes('/customise')) {
        return 'Summary';
      }
      if (pathname.includes('/comparable_rentals')) {
        return 'Comparable Rentals';
      }
      if (pathname.includes('/comparable_listings')) {
        return 'Comparable Listings';
      }
      if (pathname.includes('/comparable_sales')) {
        return 'Comparable Sales';
      }
    }
  }
  else if (pathname.indexOf('/properties/search') === 0) {
    return 'Search';
  }
  else if (document.querySelector('.login-page')) {
    return 'Login';
  }
  return 'Comparable Sales';
};

export function locationInfo(pathname) {
  return {
    pageContext: pageContext(pathname),
    propertyId: propertyId(pathname),
  };
}
